type DamageOption = { label: string; value: string };

export const damageWhereOptions: DamageOption[] = [
  { label: 'fleetadmin.damage.where.exterior', value: 'exterior' },
  { label: 'fleetadmin.damage.where.interior', value: 'interior' },
];

export const damageComponentOptions: Record<string, DamageOption[]> = {
  exterior: [
    {
      label: 'fleetadmin.damage.component.exteriorMirror',
      value: 'exteriorMirror',
    },
    { label: 'fleetadmin.damage.component.bumper', value: 'bumper' },
    {
      label: 'fleetadmin.damage.component.engineBonnet',
      value: 'engineBonnet',
    },
    { label: 'fleetadmin.damage.component.wing', value: 'wing' },
    { label: 'fleetadmin.damage.component.door', value: 'door' },
    { label: 'fleetadmin.damage.component.slidingDoor', value: 'slidingDoor' },
    { label: 'fleetadmin.damage.component.windscreen', value: 'windscreen' },
    { label: 'fleetadmin.damage.component.rearWindow', value: 'rearWindow' },
    { label: 'fleetadmin.damage.component.hubcap', value: 'hubcap' },
    { label: 'fleetadmin.damage.component.wheelRim', value: 'wheelRim' },
    { label: 'fleetadmin.damage.component.tire', value: 'tire' },
    { label: 'fleetadmin.damage.component.sill', value: 'sill' },
    { label: 'fleetadmin.damage.component.other', value: 'other' },
  ],
  interior: [
    {
      label: 'fleetadmin.damage.component.interiorTrim',
      value: 'interiorTrim',
    },
    { label: 'fleetadmin.damage.component.floor', value: 'floor' },
    { label: 'fleetadmin.damage.component.seat', value: 'seat' },
    { label: 'fleetadmin.damage.component.trunk', value: 'trunk' },
    { label: 'fleetadmin.damage.component.other', value: 'other' },
  ],
};

const front: DamageOption = {
  label: 'fleetadmin.damage.location.front',
  value: 'front',
};
const rear: DamageOption = {
  label: 'fleetadmin.damage.location.rear',
  value: 'rear',
};

export const damageLocationOptions: Record<string, DamageOption[]> = {
  exteriorMirror: [],
  bumper: [front, rear],
  engineBonnet: [],
  wing: [front, rear],
  door: [front, rear],
  windscreen: [],
  rearWindow: [],
  hubcap: [front, rear],
  wheelRim: [front, rear],
  sill: [front, rear],
  interiorTrim: [front, rear],
  floor: [front, rear],
  seat: [front, rear],
  trunk: [],
  other: [],
};

const driversSide: DamageOption = {
  label: 'fleetadmin.damage.side.driversSide',
  value: 'driversSide',
};
const coDriversSide: DamageOption = {
  label: 'fleetadmin.damage.side.coDriversSide',
  value: 'coDriversSide',
};
const center: DamageOption = {
  label: 'fleetadmin.damage.side.center',
  value: 'center',
};

export const damageSideOptions: Record<string, DamageOption[]> = {
  exteriorMirror: [driversSide, coDriversSide],
  bumper: [driversSide, center, coDriversSide],
  engineBonnet: [driversSide, center, coDriversSide],
  wing: [driversSide, coDriversSide],
  door: [driversSide, coDriversSide],
  windscreen: [driversSide, center, coDriversSide],
  rearWindow: [driversSide, center, coDriversSide],
  hubcap: [driversSide, coDriversSide],
  wheelRim: [driversSide, coDriversSide],
  sill: [driversSide, coDriversSide],
  interiorTrim: [driversSide, center, coDriversSide],
  floor: [driversSide, center, coDriversSide],
  seat: [driversSide, coDriversSide],
  trunk: [driversSide, center, coDriversSide],
  other: [],
};

const scratch: DamageOption = {
  label: 'fleetadmin.damage.characteristic.scratch',
  value: 'scratch',
};
const deepScratch: DamageOption = {
  label: 'fleetadmin.damage.characteristic.deepScratch',
  value: 'deepScratch',
};
const dent: DamageOption = {
  label: 'fleetadmin.damage.characteristic.dent',
  value: 'dent',
};
const stoneChip: DamageOption = {
  label: 'fleetadmin.damage.characteristic.stoneChip',
  value: 'stoneChip',
};
const crack: DamageOption = {
  label: 'fleetadmin.damage.characteristic.crack',
  value: 'crack',
};
const missing: DamageOption = {
  label: 'fleetadmin.damage.characteristic.missing',
  value: 'missing',
};
const burn: DamageOption = {
  label: 'fleetadmin.damage.characteristic.burn',
  value: 'burn',
};
const permanentDirt: DamageOption = {
  label: 'fleetadmin.damage.characteristic.permanentDirt',
  value: 'permanentDirt',
};
const freeText: DamageOption = {
  label: 'fleetadmin.damage.characteristic.freeText',
  value: 'freeText',
};

export const damageCharacteristicOptions: Record<string, DamageOption[]> = {
  exteriorMirror: [scratch, deepScratch, dent, stoneChip, freeText],
  bumper: [scratch, dent, freeText],
  engineBonnet: [scratch, deepScratch, dent, freeText],
  wing: [scratch, deepScratch, dent, freeText],
  door: [scratch, deepScratch, dent, freeText],
  windscreen: [crack, stoneChip],
  rearWindow: [crack, stoneChip],
  hubcap: [scratch, missing],
  wheelRim: [scratch, dent, freeText],
  sill: [scratch, deepScratch, dent, freeText],
  interiorTrim: [scratch, burn, freeText],
  floor: [permanentDirt, burn, freeText],
  seat: [permanentDirt, burn, freeText],
  trunk: [permanentDirt, burn, freeText],
  other: [freeText],
};

const lt5cm: DamageOption = {
  label: 'fleetadmin.damage.size.lt5cm',
  value: 'lt5cm',
};
const lt10cm: DamageOption = {
  label: 'fleetadmin.damage.size.lt10cm',
  value: 'lt10cm',
};
const gt10cm: DamageOption = {
  label: 'fleetadmin.damage.size.gt10cm',
  value: 'gt10cm',
};

export const damageSizeOptions: Record<string, DamageOption[]> = {
  scratch: [lt5cm, lt10cm, gt10cm],
  deepScratch: [lt5cm, lt10cm, gt10cm],
  dent: [lt5cm, lt10cm, gt10cm],
  stoneChip: [],
  crack: [lt5cm, lt10cm, gt10cm],
  missing: [],
  burn: [],
  permanentDirt: [lt5cm, lt10cm, gt10cm],
  freeText: [],
};

const flatUnique = (lists: DamageOption[][]): DamageOption[] => {
  const seen = new Set<string>();
  return lists.flat().filter((opt) => {
    if (seen.has(opt.value)) return false;
    seen.add(opt.value);
    return true;
  });
};

export const damageLocationOptionsFlat: DamageOption[] = flatUnique(
  Object.values(damageLocationOptions)
);
export const damageSideOptionsFlat: DamageOption[] = flatUnique(
  Object.values(damageSideOptions)
);
export const damageComponentOptionsFlat: DamageOption[] = flatUnique(
  Object.values(damageComponentOptions)
);
export const damageCharacteristicOptionsFlat: DamageOption[] = flatUnique(
  Object.values(damageCharacteristicOptions)
);
export const damageSizeOptionsFlat: DamageOption[] = flatUnique(
  Object.values(damageSizeOptions)
);
